import { prependStaticClass } from './helpers'

export default {
  name: 'Container',
  functional: true,
  props: {
    element: {
      type: String,
      default: 'div'
    }
  },
  render: (createElement, context) => {
    context.data.staticClass = prependStaticClass(context, ['container'])
    return createElement(context.props.element, context.data, context.children)
  }
}
